// Mock data for TRIPTO travel website

export const destinations = [
  {
    id: 'dubai',
    name: 'Dubai',
    shortDescription: 'Where luxury meets innovation',
    longDescription: 'Dubai represents the pinnacle of modern luxury and innovation. This futuristic city offers world-class shopping, stunning architecture, pristine beaches, and desert adventures, all wrapped in unparalleled hospitality and service.',
    heroImage: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3',
    highlights: ['Burj Khalifa', 'Palm Jumeirah', 'Dubai Mall', 'Desert Safari', 'Burj Al Arab', 'Dubai Marina'],
    experiences: ['Luxury Shopping', 'Desert Adventures', 'Fine Dining', 'Architectural Marvels', 'Beach Clubs', 'Spa Treatments'],
    bestTime: 'November to April',
    duration: '4-8 days',
    difficulty: 'Easy',
    currency: 'Indian Rupee (INR)',
    language: 'Arabic, English',
    sampleItineraries: [
      {
        title: 'Dubai Luxury Experience',
        duration: '5 days',
        type: 'Luxury',
        highlights: ['Luxury hotels', 'Fine dining', 'Shopping', 'Spa treatments']
      },
      {
        title: 'Dubai Adventure & Culture',
        duration: '7 days',
        type: 'Adventure',
        highlights: ['Desert safari', 'City tours', 'Water sports', 'Cultural experiences']
      }
    ],
    gallery: [
      'https://images.unsplash.com/photo-1518684079-3c830dcef090?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3',
      'https://images.unsplash.com/photo-1571227817748-70932b5d9b19?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3',
      'https://images.unsplash.com/photo-1580418827493-f2b22c0a76cb?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3'
    ]
  },
  {
    id: 'thailand',
    name: 'Thailand',
    shortDescription: 'Land of smiles and endless adventures',
    longDescription: 'Thailand enchants travelers with its golden temples, pristine beaches, bustling markets, and warm hospitality. From the cultural richness of Bangkok to the tropical paradise of the islands, Thailand offers diverse experiences for every type of traveler.',
    heroImage: 'https://images.unsplash.com/photo-1518509562904-e7ef99cdcc86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHx0cm9waWNhbCUyMHBhcmFkaXNlfGVufDB8fHx8MTc1NjQ4OTg0OXww&ixlib=rb-4.1.0&q=85',
    highlights: ['Bangkok Temples', 'Phuket Beaches', 'Chiang Mai Culture', 'Krabi Islands', 'Phi Phi Islands', 'Ayutthaya Ruins'],
    experiences: ['Temple Visits', 'Beach Escapes', 'Thai Cuisine', 'Adventure Sports', 'Floating Markets', 'Spa Treatments'],
    bestTime: 'November to March',
    duration: '7-21 days',
    difficulty: 'Easy',
    currency: 'Indian Rupee (INR)',
    language: 'Thai',
    sampleItineraries: [
      {
        title: 'Thailand Highlights',
        duration: '12 days',
        type: 'Classic',
        highlights: ['Bangkok Grand Palace', 'Chiang Mai temples', 'Island hopping', 'Beach relaxation']
      },
      {
        title: 'Thailand Beach & Culture',
        duration: '15 days',
        type: 'Leisure',
        highlights: ['Cultural immersion', 'Cooking classes', 'Beach resorts', 'Spa experiences']
      }
    ],
    gallery: [
      'https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?q=80&w=2069',
      'https://images.unsplash.com/photo-1578662996442-48f60103fc96?q=80&w=2070',
      'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?q=80&w=2070'
    ]
  },
  {
    id: 'maldives',
    name: 'Maldives',
    shortDescription: 'Paradise redefined',
    longDescription: 'The Maldives represents the ultimate tropical paradise with its crystal-clear waters, pristine white sand beaches, and luxury overwater villas. This archipelago of 1,200 coral islands offers unparalleled beauty and some of the world\'s most exclusive resorts.',
    heroImage: 'https://images.unsplash.com/photo-1544945582-052b29cd29e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHx0cm9waWNhbCUyMHBhcmFkaXNlfGVufDB8fHx8MTc1NjQ4OTg0OXww&ixlib=rb-4.1.0&q=85',
    highlights: ['Overwater Villas', 'Coral Reefs', 'Crystal Waters', 'Private Islands', 'Luxury Resorts', 'Marine Life'],
    experiences: ['Luxury Resorts', 'Underwater Adventures', 'Romantic Getaways', 'Water Sports', 'Spa Treatments', 'Sunset Cruises'],
    bestTime: 'November to April',
    duration: '4-10 days',
    difficulty: 'Easy',
    currency: 'Indian Rupee (INR)',
    language: 'Dhivehi, English',
    sampleItineraries: [
      {
        title: 'Maldives Luxury Escape',
        duration: '6 days',
        type: 'Luxury',
        highlights: ['Overwater villa', 'Private dining', 'Spa treatments', 'Water activities']
      },
      {
        title: 'Maldives Honeymoon',
        duration: '8 days',
        type: 'Romance',
        highlights: ['Romantic dinners', 'Couples spa', 'Private excursions', 'Sunset cruises']
      }
    ],
    gallery: [
      'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?q=80&w=2070',
      'https://images.unsplash.com/photo-1574935133506-7e8c69cf749c?q=80&w=2070',
      'https://images.unsplash.com/photo-1540979388789-6cee28a1cdc9?q=80&w=2070'
    ]
  },
  {
    id: 'bali',
    name: 'Bali',
    shortDescription: 'Island of gods and serenity',
    longDescription: 'Bali captivates visitors with its spiritual energy, stunning landscapes, rich culture, and warm hospitality. From ancient temples and rice terraces to beautiful beaches and vibrant arts scene, Bali offers a perfect blend of relaxation and cultural immersion.',
    heroImage: 'https://images.unsplash.com/photo-1741795854922-87217b375e79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjB0cmF2ZWwlMjBkZXN0aW5hdGlvbnN8ZW58MHx8fHwxNzU2NTAzMTAzfDA&ixlib=rb-4.1.0&q=85',
    highlights: ['Ubud Rice Terraces', 'Tanah Lot Temple', 'Seminyak Beach', 'Mount Batur', 'Uluwatu Temple', 'Tegallalang'],
    experiences: ['Wellness Retreats', 'Cultural Immersion', 'Beach Life', 'Spiritual Journeys', 'Volcano Trekking', 'Art Workshops'],
    bestTime: 'April to October',
    duration: '7-14 days',
    difficulty: 'Easy',
    currency: 'Indian Rupee (INR)',
    language: 'Indonesian, Balinese',
    sampleItineraries: [
      {
        title: 'Bali Spiritual Journey',
        duration: '5 nights 6 days',
        type: 'Wellness',
        highlights: ['Yoga retreats', 'Temple visits', 'Meditation', 'Spa treatments']
      },
      {
        title: 'Bali Culture & Beach',
        duration: '6 nights 7 days',
        type: 'Cultural',
        highlights: ['Cultural tours', 'Beach relaxation', 'Art villages', 'Traditional ceremonies']
      }
    ],
    gallery: [
      'https://images.unsplash.com/photo-1537953773345-d172ccf13cf1?q=80&w=2070',
      'https://images.unsplash.com/photo-1518548419970-58e3b4079ab2?q=80&w=2070',
      'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?q=80&w=2070'
    ]
  },
  {
    id: 'vietnam',
    name: 'Vietnam',
    shortDescription: 'Ancient traditions meet modern adventures',
    longDescription: 'Vietnam captivates visitors with its stunning natural beauty, rich cultural heritage, and vibrant cities. From the bustling streets of Ho Chi Minh City to the serene waters of Ha Long Bay, Vietnam offers an unforgettable journey through Southeast Asia\'s most fascinating destination.',
    heroImage: 'https://images.unsplash.com/photo-1557858832-b23c89645f0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHx0cm9waWNhbCUyMHBhcmFkaXNlfGVufDB8fHx8MTc1NjQ4OTg0OXww&ixlib=rb-4.1.0&q=85',
    highlights: ['Ha Long Bay', 'Ho Chi Minh City', 'Sapa Rice Terraces', 'Hoi An Ancient Town', 'Mekong Delta', 'Hanoi Old Quarter'],
    experiences: ['Cultural Tours', 'Food Adventures', 'Cruise Experiences', 'Historical Sites', 'Motorbike Tours', 'Cooking Classes'],
    bestTime: 'October to April',
    duration: '7-14 days',
    difficulty: 'Easy to Moderate',
    currency: 'Indian Rupee (INR)',
    language: 'Vietnamese',
    sampleItineraries: [
      {
        title: 'Classic Vietnam Discovery',
        duration: '10 days',
        type: 'Cultural',
        highlights: ['Hanoi city tour', 'Ha Long Bay cruise', 'Hoi An lantern festival', 'Saigon street food tour']
      },
      {
        title: 'Vietnam Adventure Trail',
        duration: '14 days',
        type: 'Adventure',
        highlights: ['Sapa trekking', 'Motorbike tours', 'Cave exploration', 'River rafting']
      }
    ],
    gallery: [
      'https://images.unsplash.com/photo-1583417319070-4a69db38a482?q=80&w=2070',
      'https://images.unsplash.com/photo-1559592413-7cec4d0d4d92?q=80&w=2071',
      'https://images.unsplash.com/photo-1587979462973-19d0958a2a9f?q=80&w=2072'
    ]
  },
  {
    id: 'sri-lanka',
    name: 'Sri Lanka',
    shortDescription: 'Pearl of the Indian Ocean',
    longDescription: 'Sri Lanka is a magical island nation offering incredible diversity within its compact size. Ancient temples, colonial architecture, pristine beaches, lush tea plantations, and abundant wildlife create a perfect blend of culture, nature, and adventure.',
    heroImage: 'https://images.unsplash.com/photo-1533689001578-f2ccb587baab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxzY2VuaWMlMjBsYW5kc2NhcGVzfGVufDB8fHx8MTc1NjUwMzExMXww&ixlib=rb-4.1.0&q=85',
    highlights: ['Sigiriya Rock', 'Kandy Temple', 'Galle Fort', 'Tea Plantations', 'Yala National Park', 'Adam\'s Peak'],
    experiences: ['Wildlife Safaris', 'Cultural Heritage', 'Beach Relaxation', 'Tea Tours', 'Train Journeys', 'Ayurveda Treatments'],
    bestTime: 'December to March',
    duration: '8-15 days',
    difficulty: 'Easy to Moderate',
    currency: 'Indian Rupee (INR)',
    language: 'Sinhala, Tamil',
    sampleItineraries: [
      {
        title: 'Sri Lanka Cultural Triangle',
        duration: '10 days',
        type: 'Cultural',
        highlights: ['Ancient cities', 'Temple visits', 'Cultural sites', 'Local traditions']
      },
      {
        title: 'Sri Lanka Wildlife & Beach',
        duration: '12 days',
        type: 'Nature',
        highlights: ['Safari adventures', 'Whale watching', 'Beach resorts', 'National parks']
      }
    ],
    gallery: [
      'https://images.unsplash.com/photo-1566636225435-2fd86c97b3d6?q=80&w=2070',
      'https://images.unsplash.com/photo-1544550058-d1091be4ae51?q=80&w=2070',
      'https://images.unsplash.com/photo-1578662996442-48f60103fc96?q=80&w=2070'
    ]
  },
  {
    id: 'nepal',
    name: 'Nepal',
    shortDescription: 'Roof of the world and spiritual sanctuary',
    longDescription: 'Nepal offers an extraordinary blend of towering Himalayan peaks, ancient temples, and rich cultural heritage. From the bustling streets of Kathmandu to the serene beauty of the Annapurna range, Nepal provides unforgettable adventures for trekkers, spiritual seekers, and culture enthusiasts alike.',
    heroImage: 'https://images.unsplash.com/photo-1544735716-392fe2489ffa?q=80&w=2070',
    highlights: ['Mount Everest', 'Kathmandu Valley', 'Annapurna Circuit', 'Pokhara Lakes', 'Chitwan National Park', 'Bhaktapur Durbar Square'],
    experiences: ['Mountain Trekking', 'Cultural Tours', 'Wildlife Safaris', 'Spiritual Journeys', 'Adventure Sports', 'Local Village Stays'],
    bestTime: 'October to December, March to May',
    duration: '10-21 days',
    difficulty: 'Moderate to Challenging',
    currency: 'Indian Rupee (INR)',
    language: 'Nepali, English',
    sampleItineraries: [
      {
        title: 'Everest Base Camp Trek',
        duration: '16 days',
        type: 'Adventure',
        highlights: ['Everest Base Camp', 'Sherpa culture', 'Mountain views', 'High altitude trekking']
      },
      {
        title: 'Nepal Cultural Heritage',
        duration: '12 days',
        type: 'Cultural',
        highlights: ['Kathmandu temples', 'Pokhara lakes', 'Traditional crafts', 'Local festivals']
      }
    ],
    gallery: [
      'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?q=80&w=2070',
      'https://images.unsplash.com/photo-1571218499448-fe27a44c3783?q=80&w=2070',
      'https://images.unsplash.com/photo-1605540436563-5bca919ae766?q=80&w=2070'
    ]
  },
  {
    id: 'united-kingdom',
    name: 'United Kingdom',
    shortDescription: 'Timeless heritage meets modern sophistication',
    longDescription: 'The United Kingdom combines centuries of rich history with contemporary innovation. From the royal palaces of London to the rugged landscapes of Scotland, the charming villages of the Cotswolds to the mystical castles of Wales, the UK offers diverse experiences steeped in tradition and culture.',
    heroImage: 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=2070',
    highlights: ['Big Ben & Parliament', 'Edinburgh Castle', 'Stonehenge', 'Lake District', 'Tower of London', 'Windsor Castle'],
    experiences: ['Royal Heritage Tours', 'Countryside Escapes', 'Literary Journeys', 'Pub Culture', 'Historic Castles', 'Theatre & Arts'],
    bestTime: 'May to September',
    duration: '7-21 days',
    difficulty: 'Easy',
    currency: 'Indian Rupee (INR)',
    language: 'English',
    sampleItineraries: [
      {
        title: 'Classic Britain Explorer',
        duration: '14 days',
        type: 'Cultural',
        highlights: ['London landmarks', 'Edinburgh festival', 'Cotswolds villages', 'Historic Bath']
      },
      {
        title: 'Royal Britain Experience',
        duration: '10 days',
        type: 'Heritage',
        highlights: ['Royal palaces', 'Crown jewels', 'Windsor Castle', 'Buckingham Palace']
      }
    ],
    gallery: [
      'https://images.unsplash.com/photo-1486299267070-83823f5448dd?q=80&w=2071',
      'https://images.unsplash.com/photo-1520986606214-8b456906c813?q=80&w=2070',
      'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?q=80&w=2070'
    ]
  }
];

export const services = [
  {
    id: 'custom-itineraries',
    title: 'Custom Itineraries',
    description: 'Tailored travel experiences crafted specifically for your preferences and interests.',
    icon: 'Map',
    detailedDescription: 'Our expert travel planners work closely with you to create personalized itineraries that match your travel style, interests, and budget. From adventure seekers to luxury travelers, we craft unique experiences that exceed expectations.',
    features: ['Personalized consultation', 'Flexible scheduling', 'Local insider experiences', '24/7 support during travel'],
    pricing: 'From ₹16,500 per itinerary',
    priceINR: 16500
  },
  {
    id: 'visa-assistance',
    title: 'Visa Assistance',
    description: 'Complete visa support and documentation guidance for hassle-free travel.',
    icon: 'FileText',
    detailedDescription: 'Navigate complex visa requirements with our comprehensive assistance service. We handle documentation, application processes, and provide expert guidance to ensure smooth entry to your destination.',
    features: ['Document preparation', 'Application tracking', 'Expert guidance', 'Expedited processing'],
    pricing: 'From ₹8,200 per visa application',
    priceINR: 8200
  },
  {
    id: 'luxury-accommodations',
    title: 'Luxury Accommodations',
    description: 'Handpicked premium hotels and resorts for unforgettable stays.',
    icon: 'Building',
    detailedDescription: 'Access exclusive accommodations through our premium partnerships. From boutique hotels to world-class resorts, we secure the best rates and special amenities for our clients.',
    features: ['Exclusive partnerships', 'Room upgrades', 'Special amenities', 'Best rate guarantee'],
    pricing: 'Competitive rates with added value',
    priceINR: 0
  },
  {
    id: 'transportation',
    title: 'Transportation- Flight Bookings & Ground Transportation',
    description: 'Seamless flight bookings and ground transportation arrangements.',
    icon: 'Plane',
    detailedDescription: 'Complete transportation solutions including flights, transfers, and local transport. Our global network ensures reliable and comfortable travel arrangements worldwide.',
    features: ['Flight bookings', 'Airport transfers', 'Private transportation', 'Multi-city arrangements'],
    pricing: 'Market rates with premium service',
    priceINR: 0
  },
  {
    id: 'travel-consultancy',
    title: 'Travel Consultancy',
    description: 'Expert advice and planning support from our experienced travel specialists.',
    icon: 'Users',
    detailedDescription: 'Benefit from our decades of travel expertise. Our consultants provide insights, recommendations, and planning support to ensure your trip is perfectly tailored to your needs.',
    features: ['Expert advice', 'Destination insights', 'Travel planning', 'Risk assessment'],
    pricing: 'Complimentary with bookings',
    priceINR: 0
  },
  {
    id: 'group-travel',
    title: 'Group Travel',
    description: 'Specialized corporate and group travel solutions with dedicated support.',
    icon: 'UsersRound',
    detailedDescription: 'Comprehensive group travel management for corporate events, family reunions, and special occasions. We handle logistics, negotiations, and coordination for groups of all sizes.',
    features: ['Group coordination', 'Dedicated manager', 'Special group rates', 'Logistics management'],
    pricing: 'Custom pricing for groups 10+',
    priceINR: 0
  },
  {
    id: 'corporate-travel',
    title: 'Corporate Travel',
    description: 'Professional business travel management with comprehensive corporate solutions.',
    icon: 'Briefcase',
    detailedDescription: 'Streamlined corporate travel services designed for businesses of all sizes. From executive travel to team events, we provide cost-effective solutions with detailed reporting and 24/7 support.',
    features: ['Executive travel planning', 'Corporate event management', 'Travel policy compliance', 'Expense reporting & analytics'],
    pricing: 'Starting from ₹25,000 per month',
    priceINR: 25000
  }
];

export const whyChooseUs = [
  {
    title: 'Tailored Experiences',
    description: 'Every itinerary is crafted specifically for your preferences, ensuring a unique and personalized journey.',
    icon: 'Target',
    details: 'Our travel experts spend time understanding your interests, travel style, and preferences to create completely personalized experiences that reflect who you are and what you love.'
  },
  {
    title: 'Expert Local Knowledge',
    description: 'Our team\'s deep understanding of each destination guarantees authentic and insider experiences.',
    icon: 'MapPin',
    details: 'With local partnerships and on-ground expertise in every destination, we provide access to hidden gems, exclusive experiences, and authentic cultural encounters that typical tourists never discover.'
  },
  {
    title: '24/7 Support',
    description: 'Round-the-clock assistance throughout your journey for complete peace of mind.',
    icon: 'Clock',
    details: 'Our dedicated support team is available 24/7 during your travels. Whether you need assistance, have questions, or face unexpected situations, we\'re always just a phone call away.'
  },
  {
    title: 'Competitive Pricing',
    description: 'Best value for your investment with transparent pricing and no hidden costs.',
    icon: 'DollarSign',
    details: 'Through our extensive network and volume partnerships, we secure the best rates for accommodations, activities, and services, passing the savings directly to you.'
  },
  {
    title: 'Digital-First Approach',
    description: 'Seamless booking and communication through our modern digital platform.',
    icon: 'Smartphone',
    details: 'Our technology-driven approach ensures efficient planning, real-time communication, and easy access to your travel documents and itineraries through our digital platform.'
  },
  {
    title: 'Trusted Network',
    description: 'Partnerships with premium suppliers and accommodations worldwide.',
    icon: 'Shield',
    details: 'Our carefully vetted network of suppliers, guides, and accommodations ensures quality, reliability, and exceptional service standards across all our destinations.'
  }
];

export const blogPosts = [
  // Custom blogs - Add your blogs here
  {
    id: 7,
    title: 'Your Custom Blog Title 1',
    excerpt: 'Brief description of your first custom blog post. This will appear in the blog preview cards.',
    content: `Your full blog content here. You can use markdown formatting like:

## Main Headings

Use ## for main section headings

### Subheadings

Use ### for subsections

**Bold text** and *italic text* are supported.

Write your paragraphs normally and they will be formatted correctly.`,
    image: 'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?q=80&w=2072',
    date: '2024-12-20',
    category: 'Custom',
    author: 'TRIPTO Team',
    readTime: '5 min read',
    tags: ['Custom', 'Travel Tips', 'Personal Experience']
  },
  {
    id: 8,
    title: 'Your Custom Blog Title 2',
    excerpt: 'Brief description of your second custom blog post.',
    content: `Your second blog content here...`,
    image: 'https://images.unsplash.com/photo-1499750310107-5fef28a66643?q=80&w=2070',
    date: '2024-12-18',
    category: 'Custom',
    author: 'TRIPTO Team',
    readTime: '7 min read',
    tags: ['Custom', 'Travel', 'Guide']
  },
  // Existing blogs
  {
    id: 1,
    title: 'Ultimate Guide to Dubai: Luxury Meets Innovation',
    excerpt: 'Discover the perfect blend of modern marvels and traditional charm in the jewel of the UAE. From towering skyscrapers to golden deserts, Dubai offers experiences beyond imagination.',
    content: `Dubai stands as a testament to human ambition and innovation, transforming from a small fishing village to one of the world's most glamorous destinations. This comprehensive guide explores the best of what Dubai has to offer, from its iconic architecture to its rich cultural heritage.

## Modern Marvels

The Burj Khalifa, standing at 828 meters, dominates Dubai's skyline and offers breathtaking views from its observation decks. The Dubai Mall, one of the world's largest shopping centers, combines retail therapy with entertainment, featuring an aquarium, ice rink, and dancing fountains.

## Desert Adventures

Beyond the urban landscape, Dubai's desert offers thrilling adventures. Experience traditional Bedouin culture with camel rides, falconry displays, and authentic Arabic cuisine under the stars. Dune bashing and sandboarding provide adrenaline-pumping excitement for adventure seekers.

## Culinary Excellence

Dubai's culinary scene reflects its multicultural population, offering everything from street food to Michelin-starred dining. Don't miss trying traditional Emirati dishes like machboos and luqaimat, alongside international cuisine from world-renowned chefs.

## Luxury and Relaxation

The city's beach clubs and spas provide the perfect retreat from the bustling city life. Enjoy pristine beaches along the Persian Gulf or indulge in world-class spa treatments that blend modern techniques with ancient traditions.`,
    image: 'https://images.unsplash.com/photo-1634635976405-934ffb77aaf1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxzY2VuaWMlMjBsYW5kc2NhcGVzfGVufDB8fHx8MTc1NjUwMzExMXww&ixlib=rb-4.1.0&q=85',
    date: '2024-12-15',
    category: 'Destinations',
    author: 'Sarah Johnson',
    readTime: '8 min read',
    tags: ['Dubai', 'Luxury Travel', 'Middle East', 'City Guide']
  },
  {
    id: 2,
    title: '10 Hidden Gems in Bali You Must Visit',
    excerpt: 'Beyond the popular beaches and temples, discover Bali\'s secret treasures that few tourists know about. These hidden gems offer authentic experiences away from the crowds.',
    content: `While Bali's popular destinations like Ubud and Seminyak attract millions of visitors, the island holds countless hidden treasures waiting to be discovered. This guide reveals ten lesser-known gems that showcase Bali's authentic beauty and culture.

## Secret Waterfalls

Venture beyond the crowded Sekumpul Falls to discover hidden cascades like Banyumala Twin Falls and Aling-Aling Falls. These pristine locations offer perfect swimming opportunities and stunning photo spots without the tourist masses.

## Traditional Villages

Experience authentic Balinese culture in traditional villages like Tenganan and Trunyan, where ancient customs and traditions are preserved. These communities offer insights into Bali's rich heritage and provide opportunities to interact with locals who maintain traditional ways of life.

## Hidden Beaches

Discover secluded beaches like Green Bowl Beach and Bias Tugel, where white sand and clear waters provide perfect retreats from Bali's more crowded coastal areas. These hidden paradises offer tranquility and natural beauty in their purest form.

## Ancient Temples

Explore lesser-known temples like Goa Gajah and Gunung Kawi, which showcase Bali's spiritual heritage without the crowds of more famous sites. These ancient sanctuaries offer peaceful environments for reflection and cultural appreciation.`,
    image: 'https://images.pexels.com/photos/19045886/pexels-photo-19045886.jpeg',
    date: '2024-12-10',
    category: 'Travel Tips',
    author: 'Michael Chen',
    readTime: '6 min read',
    tags: ['Bali', 'Hidden Gems', 'Indonesia', 'Off the Beaten Path']
  },
  {
    id: 3,
    title: 'Planning Your Perfect Maldives Honeymoon',
    excerpt: 'Everything you need to know about creating the most romantic getaway in paradise. From choosing the right resort to planning unforgettable experiences.',
    content: `The Maldives represents the ultimate honeymoon destination, with its crystal-clear waters, pristine beaches, and luxurious overwater villas. This comprehensive guide helps you plan the perfect romantic escape in this tropical paradise.

## Choosing the Perfect Resort

With over 100 resorts spread across 1,200 coral islands, selecting the right resort is crucial. Consider factors like accessibility, villa types, dining options, and activities available. All-inclusive packages often provide the best value for honeymooners.

## Romantic Experiences

Plan special moments like private beach dinners under the stars, couples' spa treatments, sunset cruises, and underwater dining experiences. Many resorts offer honeymoon packages with romantic perks and special amenities.

## Best Time to Visit

The Maldives enjoys a tropical climate year-round, but the best weather occurs from November to April during the dry season. This period offers the most sunshine and calm seas, perfect for water activities and relaxation.

## Activities for Couples

From snorkeling with manta rays to private island picnics, the Maldives offers countless romantic activities. Consider diving excursions, fishing trips, cultural visits to local islands, and spa treatments designed for couples.`,
    image: 'https://images.pexels.com/photos/261204/pexels-photo-261204.jpeg',
    date: '2024-12-05',
    category: 'Romance',
    author: 'Emma Williams',
    readTime: '10 min read',
    tags: ['Maldives', 'Honeymoon', 'Luxury Travel', 'Romance']
  },
  {
    id: 4,
    title: 'Vietnam Street Food Adventure: A Culinary Journey',
    excerpt: 'Explore the vibrant street food culture of Vietnam, from pho in Hanoi to banh mi in Ho Chi Minh City. Discover the flavors that define Vietnamese cuisine.',
    content: `Vietnam's street food scene is legendary, offering an incredible array of flavors, textures, and aromas that define the country's culinary identity. This guide takes you on a delicious journey through Vietnam's most iconic street foods and where to find them.

## Northern Delights

Hanoi's Old Quarter buzzes with street food vendors serving traditional dishes like pho bo (beef noodle soup), bun cha (grilled pork with noodles), and fresh spring rolls. Don't miss trying egg coffee, a Hanoi specialty that combines Vietnamese coffee with whipped egg.

## Central Flavors

Hue and Hoi An offer unique regional specialties like cao lau (Hoi An noodles), white rose dumplings, and bun bo Hue (spicy beef noodle soup). The central region's cuisine balances the fresh herbs of the south with the hearty flavors of the north.

## Southern Spices

Ho Chi Minh City's street food scene features bold flavors and fresh ingredients. Must-try dishes include banh mi (Vietnamese sandwiches), com tam (broken rice), and fresh tropical fruits. The southern cuisine incorporates more sugar and coconut milk, creating distinctive sweet and savory combinations.

## Street Food Etiquette

Learn the basics of Vietnamese street food culture, including how to order, proper eating techniques, and food safety tips. Most vendors specialize in one or two dishes, perfecting their recipes over generations.`,
    image: 'https://images.unsplash.com/photo-1559592413-7cec4d0d4d92?q=80&w=2071',
    date: '2024-11-28',
    category: 'Food & Culture',
    author: 'David Nguyen',
    readTime: '7 min read',
    tags: ['Vietnam', 'Street Food', 'Culinary Travel', 'Cultural Experience']
  },
  {
    id: 5,
    title: 'Sri Lanka: The Pearl of the Indian Ocean',
    excerpt: 'Discover why Sri Lanka captivates travelers with its diverse landscapes, ancient heritage, and warm hospitality. A complete guide to this incredible island nation.',
    content: `Sri Lanka, despite its compact size, offers an incredible diversity of experiences that rival much larger countries. From ancient kingdoms and colonial cities to pristine beaches and wildlife-rich national parks, this island nation truly lives up to its reputation as the "Pearl of the Indian Ocean."

## Ancient Wonders

The Cultural Triangle, encompassing Anuradhapura, Polonnaruwa, and Kandy, showcases Sri Lanka's rich Buddhist heritage. Sigiriya Rock Fortress stands as one of the world's most spectacular archaeological sites, while the Temple of the Sacred Tooth Relic in Kandy remains an active pilgrimage site.

## Natural Beauty

From the misty hills of Ella and Nuwara Eliya to the golden beaches of the south coast, Sri Lanka's landscapes are breathtaking. The famous tea plantations create a patchwork of green across the highlands, while national parks like Yala offer excellent wildlife viewing opportunities.

## Cultural Experiences

Sri Lankan culture blends Sinhalese, Tamil, Muslim, and colonial influences, creating a unique tapestry of traditions. Experience traditional dance performances, participate in religious festivals, and learn about the island's famous tea production process.

## Wildlife Encounters

Sri Lanka boasts an impressive array of wildlife, including elephants, leopards, and over 400 bird species. Udawalawe and Minneriya national parks offer excellent elephant watching, while Yala National Park provides the best chances of spotting leopards.`,
    image: 'https://images.unsplash.com/photo-1566636225435-2fd86c97b3d6?q=80&w=2070',
    date: '2024-11-20',
    category: 'Destinations',
    author: 'Priya Perera',
    readTime: '9 min read',
    tags: ['Sri Lanka', 'Cultural Heritage', 'Wildlife', 'Island Travel']
  },
  {
    id: 6,
    title: 'Thailand Island Hopping: Paradise Found',
    excerpt: 'Navigate Thailand\'s stunning islands from the Andaman Sea to the Gulf of Thailand. Discover pristine beaches, vibrant coral reefs, and island culture.',
    content: `Thailand's islands offer some of the world's most beautiful tropical destinations, each with its own character and attractions. This comprehensive guide helps you navigate the best islands for your perfect Thai getaway.

## Andaman Sea Islands

The western coast features dramatic limestone cliffs and crystal-clear waters. Phuket serves as the main hub, while Phi Phi Islands offer stunning scenery and vibrant nightlife. Krabi province includes beautiful islands like Koh Lanta and the famous James Bond Island.

## Gulf of Thailand

The eastern islands provide a different but equally spectacular experience. Koh Samui offers luxury resorts and beautiful beaches, while Koh Phangan is famous for its Full Moon Parties. Koh Tao is renowned as one of the world's best diving destinations.

## Island Activities

Each island offers unique activities and experiences. Enjoy world-class diving and snorkeling, rock climbing on limestone cliffs, kayaking through mangrove forests, and exploring hidden lagoons and caves. Cultural experiences include visiting local fishing villages and Buddhist temples.

## Best Times to Visit

The Andaman Sea islands are best visited from November to April, while the Gulf of Thailand islands have their peak season from December to March. Consider the monsoon seasons when planning your island-hopping adventure.`,
    image: 'https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?q=80&w=2069',
    date: '2024-11-15',
    category: 'Island Travel',
    author: 'Alex Thompson',
    readTime: '8 min read',
    tags: ['Thailand', 'Islands', 'Beach Travel', 'Southeast Asia']
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Shreyash',
    location: 'India',
    rating: 5,
    text: 'TRIPTO made our Maldives honeymoon absolutely perfect! Every detail was carefully planned and the personalized service exceeded our expectations. The overwater villa was magical and the private dining experience was unforgettable.',
    trip: 'Maldives Honeymoon',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?q=80&w=150'
  },
  {
    id: 2,
    name: 'Ritika',
    location: 'India',
    rating: 5,
    text: 'The Vietnam cultural tour was incredible. Our guide was knowledgeable and the itinerary perfectly balanced must-see sights with authentic local experiences. The street food tours in Hanoi were a highlight!',
    trip: 'Vietnam Cultural Tour',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?q=80&w=150'
  },
  {
    id: 3,
    name: 'Sayali',
    location: 'India',
    rating: 5,
    text: 'TRIPTO\'s attention to detail is remarkable. Our Thailand adventure was seamlessly organized with amazing accommodations and unforgettable experiences. The island hopping was perfectly planned.',
    trip: 'Thailand Adventure',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?q=80&w=150'
  },
  {
    id: 4,
    name: 'Bhargav',
    location: 'United Kingdom',
    rating: 5,
    text: 'Our Sri Lanka wildlife safari exceeded all expectations. TRIPTO arranged exclusive access to national parks and we saw leopards, elephants, and countless bird species. Truly a trip of a lifetime.',
    trip: 'Sri Lanka Wildlife Safari',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?q=80&w=150'
  },
  {
    id: 5,
    name: 'Runali',
    location: 'India',
    rating: 5,
    text: 'The Dubai luxury experience curated by TRIPTO was phenomenal. From the Burj Al Arab to desert glamping, every moment was extraordinary. Their local connections made all the difference.',
    trip: 'Dubai Luxury Experience',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?q=80&w=150'
  },
  {
    id: 6,
    name: 'Sanket',
    location: 'Brazil',
    rating: 5,
    text: 'Bali spiritual journey with TRIPTO was transformative. The yoga retreats, temple visits, and cultural immersion were perfectly balanced. Their understanding of local customs was impressive.',
    trip: 'Bali Spiritual Journey',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?q=80&w=150'
  }
];

export const travelTypes = [
  {
    id: 'honeymoon',
    title: 'Honeymoon',
    description: 'Romantic escapes for newlyweds',
    image: 'https://images.unsplash.com/photo-1552873547-b88e7b2760e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjB0cmF2ZWwlMjBkZXN0aW5hdGlvbnN8ZW58MHx8fHwxNzU2NTAzMTAzfDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'adventure',
    title: 'Adventure',
    description: 'Thrilling experiences for explorers',
    image: 'https://images.unsplash.com/photo-1617383071491-44c3d8f720d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxzY2VuaWMlMjBsYW5kc2NhcGVzfGVufDB8fHx8MTc1NjUwMzExMXww&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'medical-tourism',
    title: 'Medical Tourism',
    description: 'World-class healthcare with travel comfort',
    image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?q=80&w=2071'
  },
  {
    id: 'family',
    title: 'Family',
    description: 'Memorable adventures for all ages',
    image: 'https://images.unsplash.com/photo-1619022092131-c87186e13c3c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxzY2VuaWMlMjBsYW5kc2NhcGVzfGVufDB8fHx8MTc1NjUwMzExMXww&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'corporate-events',
    title: 'Corporate & Events',
    description: 'Professional meetings and special occasions',
    image: 'https://images.unsplash.com/photo-1511578314322-379afb476865?q=80&w=2069'
  }
];

export const teamMembers = [
  {
    id: 1,
    name: 'Sarah Johnson',
    position: 'Founder & CEO',
    bio: 'With over 15 years in luxury travel, Sarah founded TRIPTO to make extraordinary travel accessible to everyone.',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?q=80&w=300',
    expertise: ['Luxury Travel', 'Destination Management', 'Business Strategy']
  },
  {
    id: 2,
    name: 'Michael Chen',
    position: 'Head of Operations',
    bio: 'Michael ensures seamless travel experiences with his expertise in logistics and local partnerships across Asia.',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=300',
    expertise: ['Operations Management', 'Local Partnerships', 'Quality Assurance']
  },
  {
    id: 3,
    name: 'Priya Perera',
    position: 'Cultural Experience Director',
    bio: 'Priya curates authentic cultural experiences, bringing deep local knowledge and cultural sensitivity to every journey.',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=300',
    expertise: ['Cultural Tourism', 'Local Communities', 'Sustainable Travel']
  }
];

export const companyStats = [
  {
    number: '5000+',
    label: 'Happy Travelers',
    description: 'Satisfied customers who have experienced unforgettable journeys with us'
  },
  {
    number: '8',
    label: 'Destinations',
    description: 'Carefully selected destinations across Asia, Europe and the Middle East'
  },
  {
    number: '4.9/5',
    label: 'Average Rating',
    description: 'Based on over 1,200 verified customer reviews'
  },
  {
    number: '15+',
    label: 'Years Experience',
    description: 'Combined expertise in luxury travel and destination management'
  },
  {
    number: '24/7',
    label: 'Customer Support',
    description: 'Round-the-clock assistance throughout your journey'
  },
  {
    number: '100%',
    label: 'Customized',
    description: 'Every itinerary is tailored to your unique preferences and interests'
  }
];